import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageSize } from 'src/app/enumeration/pageSize';
import { ResponseTypeCheck } from 'src/app/enumeration/response-type';
import { DataStoreService } from 'src/app/utils/data_store/data-store.service';
import { ApiCallServiceService } from '../api_call_service/api-call-service.service';
import { ProviderType } from 'src/app/enumeration/provider-type';

@Injectable({
  providedIn: 'root',
})
export class BlockPhoneApiService {
  constructor(
    private http: HttpClient,
    private store: DataStoreService,
    private api: ApiCallServiceService,
  ) { }

  getBlockPhoneLists(type: any, page: any) {
    let basePath = 'api/redeemed/kbzpaypayment/block/list';

    switch (type) {
      case ProviderType.WAVE:
        basePath = 'api/redeemed/wavepaypayment/block/list';
        break;
      case ProviderType.AYA:
        basePath = 'api/redeemed/ayapaypayment/block/list';
        break;
      case ProviderType.Phone_Bill:
        basePath = 'api/redeemed/billtopup/block/list';
        break;
    }

    const url = `${basePath}?page=${page}&pageSize=${PageSize.BLOCKPHONE_LIST}`;

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getunBlockPhoneService(phone: any, reason: any, type: any) {
    let basePath = 'api/redeemed/kbzpaypayment/unblock';
    switch (type) {
      case ProviderType.WAVE:
        basePath = 'api/redeemed/wavepaypayment/unblock';
        break;
      case ProviderType.AYA:
        basePath = 'api/redeemed/ayapaypayment/unblock';
        break;
      case ProviderType.Phone_Bill:
        basePath = 'api/redeemed/billtopup/unblock';
        break;
    }

    const url = basePath + '?blockPhone=' + phone + '&reason=' + reason;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }
}
